export enum HeaderSearchFilterOptions {
  EVERYTHING = 'Everything',
  CUSTOMERS = 'Client',
  BOOKKEEPING = 'ClientBookKeeping',
  TAX_CASES = 'Taxes',
  AUDIT_CASES = 'Audit',
  FIN_MANAGEMENT = 'Finance',
  DIGITAL_FOLDER = 'DigitalFolder',
  TASKS = 'Tasks',
  ALL = 'All',
}
